<template>
    <section class="content-header">
        <slot name="titulo">
            <h1>
                <i v-if="icone" :class="icone" />
                {{ titulo }}
            </h1>
        </slot>
        <ol class="breadcrumb">
            <li>
                <b-link 
                    v-if="itens.length > 0" 
                    :href="dashboardUrl"
                    @click.prevent="acessarInicio"
                >
                    <i class="fa fa-home" />
                    Início
                </b-link>
                <div v-else>
                    <span class="active">
                        <i class="fa fa-home" />
                        Início
                    </span>
                </div>
            </li>
            <li v-for="(item, index) in itens" :key="index" :class="index == itens.length - 1 ? 'active' : ''">
                <template v-if="item.url">
                    <router-link :to="item.url">
                        {{ item.descricao }}
                    </router-link>
                </template>
                <template v-else>
                    {{ item.descricao }}
                </template>
            </li>
        </ol>
    </section>
</template>

<script>
import { removeCookieModulo } from '@/shared/common/functions/cookies'
export default {
    name: 'BarraTitulo',
    props: {
        titulo: {
            type: String,
            required: true
        },
        icone: {
            type: String,
            required: false,
            default: ''
        },
        itens: {
            type: Array,
            required: true
        }
    },
    computed: {
        dashboardUrl() {
            if (
                this.$usuarioLogado 
                && this.$usuarioLogado.Modalidade
            ) {
                return this.$usuarioLogado.Modalidade.url_dashboard || '/inicio';
            }
            return '/inicio';
        },
    },
    methods: {
        acessarInicio() {
            this.$loading.show();
            removeCookieModulo();
            location.href = this.dashboardUrl;
        },
    }
}
</script>
